import React from 'react';
import './Bottombar.css';

import logo from './logo.svg'

// class="active"

const Bottombar = () => {
	return <div className="navbar">
	  <a href="https://www.giraffe.build/solutions/urbanize?utm_source=urbanize_dashboard&utm_medium=webpage&utm_campaign=Initial_Launch&utm_id=urbanize_referrals" target="_parent" >
		
		<img src={logo} alt="Giraffe Logo" />
	</a>
	
	</div>
}


export default Bottombar;


